module.exports = {
    'main_color': `#009bff`,
    // 头部样式变量
    'header_height': '60px',
    'header_background': `#ffffff`,
    'header_color': `#2a3f54`,
    'header_padding': `15px`,
    // 左侧菜单样式变量
    'menu_background': `#4d6987`,
    'menu_color': `#fff`,
    'menu_active_color': `#ffd04b`,
    // 主视图区样式变量
    'main_base_color': `#EEEEEE`,
    'main_body_padding': '8px',
    'space_n': '8px',
    'space_s': '10px',
    'space_m': '12px',
    'space_l': '15px',
    'border_color_eee': '#EBEEF5',
    'main_searchbar_height': "40px",
    'main_searchbar_btn_color': `#2d8cf0`,
    'main_white':`#ffffff`,
    'main_primary_color':`#3e73f6`,
    'main_font_normal_color':`#545454`
};